import MessagePage from '../../../components/Controls/GenericMessagePage/MessagePage';
import useHideTowerLayout from '../../../TowerLayout/hooks/hideTowerLayout';

function Forbidden() {
    useHideTowerLayout();

    return (
        <MessagePage
            title="403"
            smallMsgs={['Unfortunately, you do not have permission to view this page.']}
            buttonText="Back to home"
            onButtonClick={() => (window.location.href = '/')}
        />
    );
}

export default Forbidden;
